import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';

declare var ko: any;

export class configTagsEdit_template extends vnTemplate {
    public imagePicker: imagePicker_template;
    protected datePicker: filterSingleDate_template;

    protected getTemplateHtml(): string {

        return `
            <div class="form-header">
                <h3 class="form-title icon i-user">Edit Tag</h3>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <label for="name" class="form-label">Name</label>
                        <input id="name" data-bind="value: name" type="text" class="input-text" disabled>
                     </div>
                     <div class="form-group">
                        <label for="slug" class="form-label">Slug</label>
                        <input id="slug" data-bind="value: slug, disable: hasSlug" type="text" class="input-text">
                     </div>
                     <div class="form-group">
                        <label for="slug" class="form-label">Tag Type</label>
                        <input id="slug" data-bind="value: tagType, disable: tagType() != null" type="text" class="input-text">
                     </div>
                    <div class="form-group">
                        <label for="description" class="form-label">Description</label>
                        <textarea id="description" data-bind="value: description"></textarea>
                    </div>
                    <div class="form-group">
                        <input id="isSelectable" type="checkbox" data-bind="checked: isSelectable"/>
                         <label for="isSelectable" class="form-label icon i-check">Active </label>
                    </div>
                    <div class="form-group row" >
                            <label class="form-label">Tag Image</label>
                            <button class="btn icon only-icon i-add" type="btn" data-bind="event: { click: onClickAddTagImage }, css: { 'no-selection' : tagImage() && tagImage().url == null }"></button>
                        </div>
                    <div class="form-group img"> 
                        <div class="w-img" id="tagImage" data-bind="visible: tagImage() != null">
                            <img style="width: 290px;" data-bind="attr: { src: tagImage() != null ? tagImage().url : '' }"  alt="image not found" />
                            <button class="btn-form icon i-close" type="button" data-bind="event: { click: onClickCloseTagImage }"><span>close</span></button>                                
                        </div>
                        <button class="btn-form icon i-view" data-bind="event: { click: onClickViewTagImage },visible: tagImage() != null && tagImage().url != null"><span>view</span></button>
                        <button class="btn-form icon i-edit" data-bind="event: { click: onClickEditTagImage }, visible: tagImage() != null && tagImage().url != null"><span>edit</span></button>
    
                    </div>
                </div>  
                <div class="form-body">
                        <div id="spec_section" class="form-group  specification" >
                            <div id="spec_section_list" data-bind="foreach: specifications">
                                <div>
                                    <div>
                                        <input type="checkbox" disabled="disabled" data-bind="checked: isForcedOverwrite, attr:{id:'spec-selected-' + $index()}" >
                                        <label data-bind="attr:{for:'spec-selected-' + $index()}" class="form-label icon i-check">Is Forced Overwrite ?</label>   
                                        <!-- REPLACE BY THIS
                                        <div class="align-center" data-bind="if: isForcedOverwrite">
                                            <span class="check icon i-check" ></span>
                                        </div>  
                                        -->         
                                    </div>
                                    <div>
                                        <span data-bind="text: label, enable: isAdded">
                                    </div>
                                    <div>
                                        <span data-bind="text: type.name">
                                    </div>
                                    <div data-bind="visible: type.id == 1">
                                        <span data-bind="text: (data ? data : '')">
                                    </div>
                                    <div data-bind="visible: type.id == 2">
                                        <span data-bind="text: (data ? data.name : '')">
                                    </div>
                                    <div data-bind="visible: type.id == 3">
                                        <ul data-bind="foreach: data">                                    
                                            <li class="item-tag">
                                                <span class="form-tag" data-bind="text: tag.name"</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <button type="button" class="btn icon only-icon i-edit" data-bind="event: {click: $parent.onClickEditSpecification.bind($index) }"></button>
                                </div>
                            </div>    
                        </div>
                    </div>
                 </div> 
            ` + this.imagePicker.getHtmlBuild() + `
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
            
            <div data-bind="css: { 'is-visible': isAddSpecVisible }" class="w-lightbox is-visible light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:50rem;">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: popupTitle"></h3>
                        </div>
                        
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Field Name</label>
                                <input type="text" class="input-text"  data-bind="value: specificationLabel, disable: idField">
                            </div>
                            <div>
                                <input type="checkbox" data-bind="checked: specificationIsForcedOverwrite, enable: !idField" id="specificationIsForcedOverwrite" >
                                <label for="specificationIsForcedOverwrite" class="form-label icon i-check">Is Forced Overwrite ?</label>           
                            </div>
                            <div class="form-group">
                                <label class="form-label">Value</label>
                                <select id="" data-bind="options: specTypes_options, disable: idField, optionsCaption: 'Choose an option', optionsText: 'name', value: selectedSpecType, optionsValue: 'id', event: { change: onChangeSpecificationType }"></select>
                            </div>
                            <div class="form-group" data-bind="visible: selectedSpecType() == 2 || selectedSpecType() == 3, disable: idField">
                                <label class="form-label">Tag Restriction</label>
                                
                                <div class="row icon i-auto-complete-a">
                                    <input class="input-text" list="product-types" type="text" data-bind="event:{ blur: onBlurRestrictionType }, value: restrictionType, disable: idField" />
                                    <datalist id="product-types" data-bind="foreach: tagType_options">
                                        <option data-bind="value: name">
                                    </datalist>
                                </div>
                            </div>
                            <div class="form-group" data-bind="visible: selectedSpecType() == 1">
                                <label class="form-label">Data</label>
                                <input type="text" class="input-text" data-bind="value: specificationData">
                            </div>
                            <div class="form-group" data-bind="visible: selectedSpecType() == 2">
                                <label class="form-label">Tag</label>
                                <select id="" data-bind="options: tag_options, optionsCaption: 'Choose an option', optionsText: 'name', value: selectedTag, optionsValue: 'id'"></select>
                            </div>
                            <div class="form-group" data-bind="visible: selectedSpecType() == 3">
                                <label class="form-label">Tags</label>
                                <select id="" multiple="multiple" data-bind="options: tag_options, optionsCaption: 'Choose an option', optionsText: 'name', selectedOptions: selectedTags, optionsValue: 'id'"></select>
                             </div>
                            <div class="form-group" data-bind="visible: selectedSpecType() == 4">
                                <label class="form-label">Date</label>
                                ${this.datePicker.getHtmlBuild()}
                            </div> 
                         </div>

                        <div class="form-footer">                          
                            <button type="button" data-bind="event: { click: onClickCancelSaveSpecification }" class="btn ">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSaveSpecification }" class="btn highlight">Apply</button>
                        </div>
                        
                    </div>
                </div>
             </div>
            `;
    }

    protected getTemplateName(): string {
        return "configTagsEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        let viewModel = {
            idTag: ko.observable("")
            ,
            name: ko.observable("")
            ,
            tagType: ko.observable()
            ,
            idTagType: ko.observable()
            ,
            slug: ko.observable("/tag/")
            ,
            tagImage: ko.observable()
            ,
            description: ko.observable("")
            ,
            isSelectable: ko.observable(0)
            ,
            hasSlug: ko.observable(false)
            ,
            specifications: ko.observableArray([])
            ,
            idField: ko.observable()
            ,
            isAddSpecVisible: ko.observable(false)
            ,
            specificationLabel: ko.observable(null)
            ,
            specificationIsForcedOverwrite: ko.observable(false)
            ,
            specificationData: ko.observable(null)
            ,
            specTypes_options: ko.observableArray([{id: 1, name: "Text"}, {id: 2, name: "Tag"}, {id: 3, name: "Tags"}])
            ,
            tagType_options: ko.observableArray([])
            ,
            specEdited: ko.observable()
            ,
            tag_options: ko.observableArray([])
            ,
            popupTitle: ko.observable()
            ,
            isForcedOverwrite: ko.observable()
            ,
            pendingSpecToAdd: ko.observable()
            ,
            selectedSpecType: ko.observable()
            ,
            restrictionType: ko.observable()
            ,
            idRestrictionType: ko.observable()
            ,
            selectedTag: ko.observable()
            ,
            editedSelectedTags: ko.observable()
            ,
            selectedTags: ko.observableArray()
            ,
            onClickSave: function (data, event) {
                huit_neuf_this.onClickSave();
            }
            ,
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            onClickAddTagImage: function (data, event) {
                huit_neuf_this.onClickAddTagImage();
            },
            onClickEditTagImage: function (data, event) {
                huit_neuf_this.onClickEditTagImage();
            },
            onClickViewTagImage: function (data, event) {
                huit_neuf_this.onClickViewTagImage();
            },
            onClickCloseTagImage: function (data, event) {
                huit_neuf_this.onClickCloseTagImage();
            },
            onChangeSpecificationType: function () {
                huit_neuf_this.onChangeSpecificationType();
            },
            onClickSaveSpecification: function () {
                huit_neuf_this.onClickSaveSpecification();
            },
            onClickCancelSaveSpecification: function () {
                huit_neuf_this.onClickCancelSaveSpecification();
            },
            onClickEditSpecification: function (value, data, event) {
                huit_neuf_this.onClickEditSpecification(value);
            },
            onClickDeleteSpecification: function (value, data, event) {
                huit_neuf_this.onClickDeleteSpecification(value);
            },
            onBlurRestrictionType: function (value, data, event) {
                huit_neuf_this.onBlurRestrictionType(value);
            },

        };
        return viewModel;
    }

    protected onClickSave() {

        this.caller.save()
    }

    protected onClickCancel() {

        this.caller.cancel();
    }

    public setTag(tag) {

        this.getTemplateViewModel().idTag(tag.id);
        this.getTemplateViewModel().name(tag.name);
        this.getTemplateViewModel().description(tag.details ? tag.details.description : '');
        this.getTemplateViewModel().isSelectable(tag.details ? tag.details.isSelectable : false);

        if(tag.type){
            this.getTemplateViewModel().idTagType(tag.type.id);
            this.getTemplateViewModel().tagType(tag.type.name);
        }
        let specs = [];
        if (tag.details) {

            this.getTemplateViewModel().slug(tag.details.slug);
            this.getTemplateViewModel().hasSlug(true);
            this.getTemplateViewModel().tagImage(tag.details.image);
        }

        let tagSpecs = [];
        if(tag.specifications){
            tagSpecs = tag.specifications;
        }
        let tagFields = tag.type ? tag.type.fields : [];
        specs = this.setSpecs(tagFields, tagSpecs);

        this.getTemplateViewModel().specifications(specs);
    }

    protected initPartial() : void{

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.datePicker = new filterSingleDate_template("datePicker", this.getTemplateViewModel(), this.caller);
    }

    public buildDatePickerCalendar() {

        this.datePicker.buildCalendar();
    }

    protected onClickEditTagImage(){

        let tagImage = this.getTemplateViewModel().tagImage();
        this.showImagePicker("single-select", "tagImage");
        this.imagePicker.editImage(tagImage);
    }

    protected onClickViewTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.add("is-viewing");
    }

    protected onClickCloseTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.remove("is-viewing");
    }

    protected onClickAddTagImage(){

        this.showImagePicker("single-select", "tagImage");
    }

    public showImagePicker(mode,target){

        this.imagePicker.setMode(mode);
        this.imagePicker.setTarget(target);
        this.caller.getImageData();
        this.imagePicker.show();
    }

    public setTagImage(image){

        this.getTemplateViewModel().tagImage(image);
    }

    private setSpecs(tagFields, values){
        let specs = [];

        for (let i = 0; i < tagFields.length; i++) {
            let fieldDataType = tagFields[i].dataType;
            let dataType = null;
            let fieldData = null;
            if(fieldDataType == 'text'){
                dataType = {id: 1, name: fieldDataType};
                let fieldValue = values.find(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue ? fieldValue.value : '');
            } else if(fieldDataType == 'tag') {
                dataType = {id: 2, name: fieldDataType};
                let fieldValue = values.find(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue && fieldValue.value ? fieldValue.value[0] : {});
            } else if(fieldDataType == 'tags') {
                dataType = {id: 3, name: fieldDataType};
                let fieldValue = values.find(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue && fieldValue.value? fieldValue.value : []);
            }
            specs.push({fieldId: tagFields[i].id, label: tagFields[i].label, data: fieldData, restriction: tagFields[i].restriction, type: dataType, isSelected: true, isAdded: false, isForcedOverwrite: tagFields[i].isForcedOverwrite})
        }

        return specs;
    }

    protected onClickEditSpecification(data){

        let obj = this.getTemplateViewModel().specifications().find(c => c.fieldId == data.fieldId && c.label == data.label);
        if(obj.type.id == 2 || obj.type.id == 3){
            this.caller.getTagByType(obj.restriction);
        }
        this.getTemplateViewModel().isAddSpecVisible(true);
        this.getTemplateViewModel().popupTitle('Edit Specification');
        this.getTemplateViewModel().specEdited(data);
        this.getTemplateViewModel().idField(data.fieldId);

        this.getTemplateViewModel().specificationIsForcedOverwrite(obj.isForcedOverwrite);
        this.getTemplateViewModel().selectedSpecType(obj.type.id);
        this.getTemplateViewModel().specificationLabel(obj.label);
        // this.getTemplateViewModel().tag_options(null);
        let restriction = this.getTemplateViewModel().tagType_options().find(c => c.id === obj.restriction);
        if(restriction) {
            this.getTemplateViewModel().restrictionType(restriction.name);
            this.getTemplateViewModel().idRestrictionType(obj.restriction);
        }

        if(obj.type.id == 1){
            this.getTemplateViewModel().specificationData(obj.data);
        } else if(obj.type.id == 2) {
            let data = parseInt(obj.data)
            this.getTemplateViewModel().editedSelectedTags([data]);
        } else if(obj.type.id == 3){
            let selectedTags = [];
            for (let tag of obj.data){
                selectedTags.push(tag.id)
            }
            this.getTemplateViewModel().editedSelectedTags(selectedTags)
        }  else if (obj.type.id == 4) {
            this.datePicker.setDate(obj.data);
        }

    }

    protected onClickCancelSaveSpecification() {
        this.getTemplateViewModel().isAddSpecVisible(false);
        this.getTemplateViewModel().popupTitle();
        this.getTemplateViewModel().pendingSpecToAdd(null);
        this.getTemplateViewModel().selectedSpecType(null);
        this.getTemplateViewModel().specificationData(null);
        this.getTemplateViewModel().specificationLabel(null);
        this.getTemplateViewModel().tag_options([]);
        this.getTemplateViewModel().restrictionType(null);
        this.getTemplateViewModel().idRestrictionType(null);
        this.getTemplateViewModel().isAddSpecVisible(false);
        this.getTemplateViewModel().popupTitle();
        this.getTemplateViewModel().idField();
        this.getTemplateViewModel().editedSelectedTags();
        this.getTemplateViewModel().specEdited();
    }

    protected onClickSaveSpecification() {

        let type = null;
        let data = null;
        if (this.getTemplateViewModel().selectedSpecType() == 1) {
            type = {id: 1, name: 'text'}
            data = this.getTemplateViewModel().specificationData();
        } else if (this.getTemplateViewModel().selectedSpecType() == 2) {
            type = {id: 2, name: 'tag'};
            data = {value: this.getTemplateViewModel().tag_options().find(c => c.id === this.getTemplateViewModel().selectedTag()), idField: this.getTemplateViewModel().idField()};
        } else if (this.getTemplateViewModel().selectedSpecType() == 3) {
            type = {id: 3, name: 'tags'}
            data = [];
            for (let selectedTag of this.getTemplateViewModel().selectedTags()) {
                let tag = this.getTemplateViewModel().tag_options().find(c => c.id === selectedTag);
                if (tag) {
                    data.push({idField: this.getTemplateViewModel().idField(), value: tag});
                }
            }
        }


        this.getTemplateViewModel().pendingSpecToAdd({
            fieldId: this.getTemplateViewModel().idField(),
            isAdded: true,
            label: this.getTemplateViewModel().specificationLabel(),
            data: data,
            type: type,
            canDelete: (this.getTemplateViewModel().idField() ? false : true),
            restriction: this.getTemplateViewModel().idRestrictionType(),
            isSelected: true,
            isForcedOverwrite: this.getTemplateViewModel().specificationIsForcedOverwrite()
        });

        let idField = null;
        if(this.getTemplateViewModel().specEdited()){
            idField = this.getTemplateViewModel().specEdited().fieldId;
        }
        this.caller.validateTagSpec(idField, this.getTemplateViewModel().idTagType(), this.getTemplateViewModel().specificationLabel());

    }

    public addSpecification() {

        if(this.getTemplateViewModel().specEdited()){
            let index = this.getTemplateViewModel().specifications().findIndex(c => c.fieldId == this.getTemplateViewModel().specEdited().fieldId && c.label == this.getTemplateViewModel().specEdited().label);
            let specs = this.getTemplateViewModel().specifications();
            specs[index] = this.getTemplateViewModel().pendingSpecToAdd();
            this.getTemplateViewModel().specifications([]);
            this.getTemplateViewModel().specifications(specs);
        } else {
            this.getTemplateViewModel().specifications.push(this.getTemplateViewModel().pendingSpecToAdd());
        }
        this.getTemplateViewModel().pendingSpecToAdd(null);
        this.getTemplateViewModel().selectedSpecType(null);
        this.getTemplateViewModel().specificationData(null);
        this.getTemplateViewModel().specificationLabel(null);
        this.getTemplateViewModel().tag_options([]);
        this.getTemplateViewModel().restrictionType(null);
        this.getTemplateViewModel().idRestrictionType(null);
        this.getTemplateViewModel().isAddSpecVisible(false);
        this.getTemplateViewModel().popupTitle();
        this.getTemplateViewModel().idField();
        this.getTemplateViewModel().specEdited();
        this.getTemplateViewModel().editedSelectedTags();

    }

    public onChangeSpecificationType() {

        this.getTemplateViewModel().specificationData('');
        if(this.getTemplateViewModel().selectedSpecType() == null || this.getTemplateViewModel().selectedSpecType() == 1){
            this.getTemplateViewModel().tag_options([]);
            this.getTemplateViewModel().restrictionType('');
            this.getTemplateViewModel().idRestrictionType(null);
        }
    }

    protected onClickDeleteSpecification(data) {

        let index = this.getTemplateViewModel().specifications().findIndex(element => (element.label == data.label && element.data == data.data));
        if (index > -1) {
            this.getTemplateViewModel().specifications.splice(index, 1);
        }
    }

    protected onBlurRestrictionType(data) {

        if (data.restrictionType()) {
            let selectedTagType = data.tagType_options().find(c => c.name.toLowerCase() === data.restrictionType().toLowerCase());
            if (selectedTagType) {

                let idType = selectedTagType.id;
                this.getTemplateViewModel().idRestrictionType(idType);
                if(data.selectedSpecType() == 2 || data.selectedSpecType() == 3){
                    this.caller.getTagByType(idType);
                }
            }
        }
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/configTagsEdit_template.ts